import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/** Reusable page hero for inner pages - always offsets for fixed header */
export const PageHero = ({ kicker, title, subtitle, breadcrumb = [], rightSlot }) => {
  return (
    <section className="relative pt-32 sm:pt-40 pb-12 sm:pb-16 border-b border-border bg-[hsl(225,22%,4%)]">
      <div className="absolute inset-0 -z-10 opacity-40" aria-hidden>
        <div className="absolute -top-32 -right-20 h-[420px] w-[420px] rounded-full blur-3xl bg-[hsl(var(--primary)/0.10)]" />
      </div>
      <div className="container-site">
        {breadcrumb.length > 0 && (
          <nav className="flex items-center gap-1.5 text-xs text-muted-foreground mb-6" aria-label="Breadcrumb">
            {breadcrumb.map((b, i) => (
              <span key={b.path || b.name} className="flex items-center gap-1.5">
                {b.path ? (
                  <Link to={b.path} className="hover:text-foreground uppercase tracking-[0.18em]">{b.name}</Link>
                ) : (
                  <span className="uppercase tracking-[0.18em] text-foreground">{b.name}</span>
                )}
                {i < breadcrumb.length - 1 && <ChevronRight className="h-3 w-3 opacity-60" />}
              </span>
            ))}
          </nav>
        )}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            {kicker && <p className="kicker mb-3">{kicker}</p>}
            <motion.h1
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="font-display uppercase text-foreground text-[clamp(2.25rem,6vw,5rem)] leading-[0.95] text-balance"
            >
              {title}
            </motion.h1>
            {subtitle && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.1 }}
                className="mt-5 max-w-2xl text-sm sm:text-base text-muted-foreground leading-relaxed"
              >
                {subtitle}
              </motion.p>
            )}
          </div>
          {rightSlot && <div className="lg:col-span-4 lg:justify-self-end">{rightSlot}</div>}
        </div>
      </div>
    </section>
  );
};
